<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="tabTitle"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true">
    @if (loaded) {
      <compliance-content (savingStatusChange)="isSavingStatus = $event" />
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />
